export enum Layouts {
    Boxed = 'boxed',
    FullWidth = 'full-width',
}
